module.exports = __webpack_public_path__ + "static/PANO_20131223_221316-d1e6af3be5a221284fc6f0c61eceda16.jpg";